import { render, staticRenderFns } from "./BirthdaySettings.vue?vue&type=template&id=9a7c90e6&"
import script from "./BirthdaySettings.vue?vue&type=script&lang=js&"
export * from "./BirthdaySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports